import React, { PureComponent } from 'react';
import styled from 'styled-components';
import Modal from 'react-modal';
import htmlEncode from 'js-htmlencode';

const customStyles = {
  content: {
    top: '40%',
    left: '50%',
    width: '320px',
    right: 'auto',
    bottom: 'auto',
    border: '1px solid grey',
    borderRadius: 0,
    transform: 'translate(-50%, -50%)',
  },
};

const TitleText = styled.p`
  width: 100%;
  margin-top: 45px;
  margin-bottom: 25px;
  text-align: left;
  text-transform: none;
  font-family: HelveticaNeueLTPro-Roman;
  font-weight: normal;
  font-size: 15px;
`;

const Content = styled.div`
  display: block;
  width: 85%;
  margin: auto;
`;

const CloseIcon = styled.div`
  position: absolute;
  right: 15px;
  top: 15px;
  background-image: url(/img/close.png);
  width: 30px;
  height: 30px;
  background-repeat: round;
  opacity: 0.3;
  cursor: pointer;
`;

const Input = styled.input`
  width: 100%;
  margin: ${props =>
    !props.valid && props.id === 'email' ? '8px 0 0 0' : '8px 0'};
  line-height: 2.5;
  border: ${props =>
    !props.valid && props.id === 'email' ? '1px solid #f00' : '1px solid #000'};
  color: #000;
  padding-left: 5px;
  padding-right: 5px;
  box-sizing: border-box;
  font-size: 12px;
  background-color: transparent;
  ::placeholder {
    color: #000;
    opacity: 1; /* Firefox */
  }
`;

const ActionButton = styled.button`
  width: 100%;
  text-align: center;
  height: 42px;
  margin: 25px auto;
  border: 1px solid #8c8783;
  color: #7d7773;
  background-color: transparent;
  display: inline-block;
  font-family: HelveticaNeueLTPro-Roman;
  font-size: 13px;
  line-height: 36px;
  padding: 0 20px;
  cursor: pointer;
  text-transform: uppercase;
`;

const Invalid = styled.span`
  font-size: 10px;
  color: #f00;
`;

Modal.setAppElement('#modal');

export default class LoginModal extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      dealername: '',
      dealeremail: '',
      action: 'LOGIN',
      valid: true,
    };
  }

  triggerAction() {
    const { actionFn } = this.props;
    const valid = this.validState();
    //TODO: promt error
    this.setState({ valid });
    if (valid) {
      const button = document.getElementById('modalSumit');
      if (button)
        button.innerHTML = `${
          this.state.action
        } <i class="fa fa-spinner" aria-hidden="true"></i>`;
      actionFn(this.state);
    }
  }

  closeModal() {
    const { closeModal } = this.props;
    this.setState(
      {
        dealername: '',
        dealeremail: '',
      },
      closeModal
    );
  }

  updateState(e) {
    const value = e.target.value;
    const key = e.target.id;
    this.setState({ [key]: htmlEncode(value) });
  }

  validState() {
    const { dealeremail } = this.state;
    //TODO: valid user email info
    if (this.validateEmail(dealeremail)) return true;
    return false;
  }
  validateEmail(email) {
    const re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
    return re.test(String(email).toLowerCase());
  }

  render() {
    const { valid, action } = this.state;
    const { open, data } = this.props;
    const title = 'Please enter your information.';
    const options = data.options;
    return (
      <Modal isOpen={open} style={customStyles} contentLabel="Example Modal">
        <Content>
          <CloseIcon onClick={this.closeModal.bind(this)} />
          <div>
            {' '}
            <TitleText>{title}</TitleText>
            {options &&
              options.map(op => (
                <span key={op.value}>
                  <Input
                    onBlur={this.updateState.bind(this)}
                    id={op.value}
                    key={op.value}
                    placeholder={op.label}
                    valid={valid}
                  />
                  {!valid && op.value === 'dealeremail' ? (
                    <Invalid>Invalid email</Invalid>
                  ) : (
                    ''
                  )}
                </span>
              ))}
            <ActionButton
              id="modalSumit"
              onClick={this.triggerAction.bind(this)}
            >
              {action}
            </ActionButton>
          </div>
        </Content>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/LoginModal.js